import React from "react";
import {
  Wrapper,
  Button,
  Card,
  Row,
  Icon,
  Copy,
  Bold
} from "app/NativeComponents/common";

const PropertyListButton = props => {
  if (
    props.device == "desktop" &&
    !props.isMobile &&
    props.hide_property_list &&
    !props.active_property
  ) {
    return (
      <Button
        onPress={() => {
          //toogle property list state
          props.hidePropertyList(false);
        }}
      >
        <Card
          style={{
            borderRadius: 20,
            marginLeft: 0
          }}
        >
          <Wrapper
            style={{
              padding: 5,
              paddingRight: 15,
              paddingLeft: 15,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Icon icon={"reorder"} size={18} />
          </Wrapper>
        </Card>
      </Button>
    );
  }

  return <Wrapper />;
};

export default PropertyListButton;
